export default "__VITE_ASSET__CRe3me4v__"